import { useQuery } from "@tanstack/react-query";
import api from "../api";
import { sampleReportKeys } from "../queryKeys";

const SANDBOX_NETWORK_DATA_STALE_TIME = 30 * 1000;

const useGetSandboxNetworkData = (hash: string) => {
  const { data, isFetched, isLoading, isError } = useQuery({
    queryKey: sampleReportKeys.sandboxNetworkData(hash),
    queryFn: () => api.getSandboxNetworkData(hash),
    select: ({ data: responseData }) => responseData,
    enabled: Boolean(hash),
    refetchOnMount: "always",
    staleTime: SANDBOX_NETWORK_DATA_STALE_TIME,
    meta: {
      errorMessage: "Could not retrieve sandbox network references."
    }
  });

  return { data, isFetched, isLoading, isError };
};

export default useGetSandboxNetworkData;
